import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./BlockQuote.css";
// @ts-ignore
import { Paragraph } from "./Paragraph";

export type BlockQuoteStringProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & { data: { quote: string; author?: string } };

export const BlockQuoteString = ({ data, ...props }: BlockQuoteStringProps) => {
  const { quote, author } = data;

  return (
    <blockquote className={styles.blockQuote}>
      <Paragraph className={styles.quote}>{quote}</Paragraph>
      {author && (
        <Paragraph size="smMd" className={styles.author}>
          — {author}
        </Paragraph>
      )}
    </blockquote>
  );
};
